<template>
    <div class="detailScan">
        <el-row>
            <el-col :span="12">
                <div class="flex-box">
                    <div class="checkSearch-item">
                        <el-input
                            v-model="searchData['sourceBillNo']"
                            placeholder="单据编码"
                        ></el-input>
                    </div>
                    <el-button
                        class="detailScan-back"
                        @click="back"
                        size="mini"
                        icon="el-icon-arrow-left"
                        >返回</el-button
                    >
                </div>
            </el-col>
            <el-col :span="12" class="header-right">
                <div>
                    <el-button
                        class="header-right-btn"
                        type="primary"
                        @click="getDetail"
                        size="mini"
                        icon="el-icon-search"
                        >查询</el-button
                    >
                    <mExport
                        :url="detailExport.exportUrl"
                        :params="detailExport.exportParams"
                        :name="detailExport.exportName"
                        :exportFlag="detailExport.exportFlag"
                        :listData="detailListData"
                        :titleText="detailExport.titleText"
                    >
                    </mExport>
                </div>
            </el-col>
        </el-row>
        <p>扫码率明细列表</p>
        <div class="closeStyle">
            <m-table
                ref="RegistrationTable"
                :pageTotal="pageTotal"
                :tableData="detailListData"
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                :config="tableConfig"
            >
            </m-table>
        </div>
    </div>
</template>
<script>
import mTable from '../../../../components/IdentityComponent/Main';
import mExport from '../../component/export';
import tableConfig from './tableConfig.json';
import { scanRateMonitorDetail } from '../../../../api/lcbsManagement';
export default {
    props: {
        detailSearchParams: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    components: { mTable, mExport },
    data() {
        return {
            tableConfig,
            detailExport: {
                exportUrl:
                    '/api-sn/lbcs/scanRateMonitor/scanRateMonitorDetail/export',
                exportName: '所有扫码率监控查询明细列表.xls',
                exportParams: {},
                titleText: '导出Excel',
                exportFlag: 0
            },
            detailListData: [],
            pageTotal: 0,
            pageNo: 1,
            pageSize: 10,
            searchData: {
                sourceBillNo: ''
            }
        };
    },
    methods: {
        getDetail() {
            const params = {
                ...this.detailSearchParams,
                ...this.searchData,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            scanRateMonitorDetail(params).then((res) => {
                if (res && +res.code === 0) {
                    res.data.list.forEach((item) => {
                        if (item.scanQty !== item.billQty) {
                            item.scanQtyColor = 'red';
                        }
                    });
                    this.detailListData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.detailExport.exportFlag = 1;
                }
            });
        },
        pageChange(pageNo) {
            this.pageNo = pageNo;
            this.getDetail();
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getDetail();
        },
        back() {
            this.$emit('back');
        }
    },
    mounted() {
        this.getDetail();
        this.detailExport.exportParams = this.detailSearchParams;
    }
};
</script>
<style lang="less">
.detailScan-back {
    margin-right: 10px;
}
.closeStyle {
    .nPanel .el-table {
        height: calc(100vh - 230px) !important;
    }
}
</style>
